import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import logo from "../../assets/images/common/nefos-logo-new.png";
import logoIcon from "../../assets/images/common/nefos.png";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { CiMail } from "react-icons/ci";
import { MdVisibility } from "react-icons/md";
import { RxEyeClosed } from "react-icons/rx";

import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import {
  FORGOT_PASSWORD,
  HOME_URL,
  LIST_MUSEUM,
} from "../../constants/routers";
import { userLogin } from "../../api/actions/auth";
import { CiLock } from "react-icons/ci";

import toast from "react-hot-toast";
import Box from "@mui/material/Box";
import { FcGoogle } from "react-icons/fc";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { updateFCM } from "../../api/actions/user";
import { RiErrorWarningLine } from "react-icons/ri";
import { useGoogleLogin } from "@react-oauth/google";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";
import { releaseNoteOnHome } from "../../api/actions/releaseNote";
import { useReleaseContext } from "../../store/releaseNoteContext";

// import { messaging } from "../../firebase"
// import { requestForToken } from "../../firebase";

const Login = () => {
  const [buttonloader, setButtonloader] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();
  const messaging = getMessaging();
  const [user] = useState([]);
  const { setReleaseNotes, releaseNotes } = useReleaseContext();

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Email is mandatory"),
    password: Yup.string().required("Password is mandatory"),
  });
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      selected_branch_id: "",
      branch_name: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setButtonloader(true);

      let formData = new FormData();
      formData.append("username", values.username);
      formData.append("password", values.password);
      userLogin({ formData })((response) => {
        if (response?.status) {
          formik.resetForm();
          let notificationResponse = null;
          if (response?.message === "Account suspended, contact admin") {
            toast?.error(response?.message);
            setButtonloader(false);
            return;
          }
          releaseNoteOnHome({ page: 1 })((response) => {
            if (response?.status) {
              setReleaseNotes(response?.data);
            }
          });
          const onResponse = (error, token) => {
            if (error) {
              // Display error as a toast
              // toast.error(error);
            } else {
              notificationResponse = token; // Store token in the variable

              localStorage.setItem("fcmToken", token);
              updateFCM({ fcm_token: token })((res) => {
                if (res?.status) {
                } else {
                  setButtonloader(false);
                  toast.error(response?.message);
                }
              });
              // Optionally send the token to your server here
            }
          };

          // requestForToken();
          const requestForToken = async () => {
            try {
              const supported = await isSupported();
              if (!supported) {
                console.warn(
                  "This browser doesn't support Firebase Messaging."
                );
                return;
              }
              if (!("Notification" in window)) {
                console.warn(
                  "Notifications are not supported on this device/browser."
                );
                return;
              }

              const token = await getToken(messaging, {
                vapidKey: process.env.REACT_APP_VAPID_KEY,
              });
              if (token) {
                onResponse(null, token); // Pass token to onResponse
              } else {
                console.log(
                  "No registration token available. Request permission to generate one!"
                );
              }
            } catch (error) {
              console.error("Error while fetching FCM token:", error);
            }
          };
          requestForToken();

          if (response?.data?.user?.is_superuser) {
            localStorage.setItem(
              "user_info",
              JSON.stringify(response?.data?.user)
            );
          } else {
            if (response?.data?.user?.last_login_museum === "") {
              const firstMuseumData = response?.data?.user?.admin_museums[0];

              const newUserData = {
                ...response?.data?.user,
                museum: firstMuseumData?.id,
                logo_thumbnail: firstMuseumData?.logo_thumbnail,
                museum_domain: firstMuseumData?.museum_domain_name,
                museum_name: firstMuseumData?.museum_name,
                last_used_screen: firstMuseumData?.last_used_screen
                  ? firstMuseumData?.last_used_screen
                  : "",
              };
              localStorage.setItem("user_info", JSON.stringify(newUserData));
            } else {
              const lastMuseumData = response?.data?.user?.admin_museums.find(
                (number) =>
                  number.id === response?.data?.user?.last_login_museum
              );
              if (lastMuseumData?.is_active === false) {
                const nextMuseum = response?.data?.user?.admin_museums.find(
                  (museum) => museum.is_active === true
                );

                const InactivenewMuseumUserData = {
                  ...response?.data?.user,
                  museum: nextMuseum?.id,
                  logo_thumbnail: nextMuseum?.logo_thumbnail,
                  museum_domain: nextMuseum?.museum_domain_name,
                  museum_name: nextMuseum?.museum_name,
                  last_used_screen: nextMuseum?.last_used_screen
                    ? nextMuseum?.last_used_screen
                    : "",
                };
                localStorage.setItem(
                  "user_info",
                  JSON.stringify(InactivenewMuseumUserData)
                );
              } else {
                const newMuseumUserData = {
                  ...response?.data?.user,
                  museum: lastMuseumData?.id,
                  logo_thumbnail: lastMuseumData?.logo_thumbnail,
                  museum_domain: lastMuseumData?.museum_domain_name,
                  museum_name: lastMuseumData?.museum_name,
                  last_used_screen: lastMuseumData?.last_used_screen
                    ? lastMuseumData?.last_used_screen
                    : "",
                };

                localStorage.setItem(
                  "user_info",
                  JSON.stringify(newMuseumUserData)
                );
              }
            }
          }

          if (response?.data?.is_superuser) {
            localStorage.setItem(
              "user_info",
              JSON.stringify(response?.data?.user)
            );
          }

          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem("is_logged", true);

          setTimeout(() => {
            if (response?.data?.user?.is_superuser) {
              navigate(
                `/${
                  response?.data?.museum_name
                    ? response?.data?.museum_name.split(" ").join("_")
                    : "Nefos"
                }/${LIST_MUSEUM}`
              );
            } else {
              if (response?.data?.user?.is_admin) {
                const userData = response?.data?.user?.admin_museums.find(
                  (number) =>
                    number.id === response?.data?.user?.last_login_museum
                );

                navigate(
                  `/${userData?.museum_name?.split(" ").join("_")}/${HOME_URL}`
                );
              } else {
                navigate(
                  `/${response?.data?.user?.museum_name
                    ?.split(" ")
                    .join("_")}/${HOME_URL}`
                );
              }
            }
          }, 500);
          toast.success("Logged in successfully!");
        } else {
          setButtonloader(false);
          toast.error(
            response?.message
              ? response?.message
              : "Invalid username or password"
          );
          formik.setErrors({
            ...formik?.errors,
            username: response?.message,
          });
        }
      });
    },
  });

  const exchangeCodeForTokens = async (authorizationCode) => {
    try {
      const response = await fetch("https://oauth2.googleapis.com/token", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          code: authorizationCode, // Authorization code
          client_id: process.env.REACT_APP_GOOGLE_KEY,
          client_secret: process.env.REACT_APP_CLIENT_SECRET_SSO,
          redirect_uri: window.location.origin, // Ensure it matches your OAuth config
          grant_type: "authorization_code", // Always use 'authorization_code'
        }),
      });

      const tokens = await response.json();

      if (response.ok) {
        formik.setValues({
          ...formik?.values,
          google_user_id: tokens.id_token,
        });
        let formData = new FormData();
        formData.append("google_user_id", tokens.id_token);
        userLogin({ formData })((response) => {
          if (response?.status) {
            formik.resetForm();
            let notificationResponse = null;
            if (response?.message === "Account suspended, contact admin") {
              toast?.error(response?.message);
              setButtonloader(false);
              return;
            }
            releaseNoteOnHome({ page: 1 })((response) => {
              if (response?.status) {
                setReleaseNotes(response?.data);
              }
            });
            const onResponse = (error, token) => {
              if (error) {
                // Display error as a toast
                // toast.error(error);
                console.log(error);
              } else {
                notificationResponse = token; // Store token in the variable

                localStorage.setItem("fcmToken", token);
                updateFCM({ fcm_token: token })((res) => {
                  if (res?.status) {
                  } else {
                    setButtonloader(false);
                    toast.error(response?.message);
                  }
                });
                // Optionally send the token to your server here
              }
            };

            // requestForToken();
            const requestForToken = async () => {
              try {
                const supported = await isSupported();
                if (!supported) {
                  console.warn(
                    "This browser doesn't support Firebase Messaging."
                  );
                  return;
                }
                if (!("Notification" in window)) {
                  console.warn(
                    "Notifications are not supported on this device/browser."
                  );
                  return;
                }

                const token = await getToken(messaging, {
                  vapidKey: process.env.REACT_APP_VAPID_KEY,
                });
                if (token) {
                  onResponse(null, token); // Pass token to onResponse
                } else {
                  console.log(
                    "No registration token available. Request permission to generate one."
                  );
                }
              } catch (error) {
                console.error("Error while fetching FCM token:", error);
              }
            };
            requestForToken();

            if (
              response?.data?.user?.is_superuser ||
              response?.data?.user?.is_admin === false
            ) {
              localStorage.setItem(
                "user_info",
                JSON.stringify(response?.data?.user)
              );
            } else {
              if (response?.data?.user?.last_login_museum === "") {
                const firstMuseumData = response?.data?.user?.admin_museums[0];

                const newUserData = {
                  ...response?.data?.user,
                  museum: firstMuseumData?.id,
                  logo_thumbnail: firstMuseumData?.logo_thumbnail,
                  museum_domain: firstMuseumData?.museum_domain_name,
                  museum_name: firstMuseumData?.museum_name,
                  last_used_screen: firstMuseumData?.last_used_screen
                    ? firstMuseumData?.last_used_screen
                    : "",
                };
                localStorage.setItem("user_info", JSON.stringify(newUserData));
              } else {
                const lastMuseumData = response?.data?.user?.admin_museums.find(
                  (number) =>
                    number.id === response?.data?.user?.last_login_museum
                );
                if (lastMuseumData?.is_active === false) {
                  const nextMuseum = response?.data?.user?.admin_museums.find(
                    (museum) => museum.is_active === true
                  );

                  const InactivenewMuseumUserData = {
                    ...response?.data?.user,
                    museum: nextMuseum?.id,
                    logo_thumbnail: nextMuseum?.logo_thumbnail,
                    museum_domain: nextMuseum?.museum_domain_name,
                    museum_name: nextMuseum?.museum_name,
                    last_used_screen: nextMuseum?.last_used_screen
                      ? nextMuseum?.last_used_screen
                      : "",
                  };
                  localStorage.setItem(
                    "user_info",
                    JSON.stringify(InactivenewMuseumUserData)
                  );
                } else {
                  const newMuseumUserData = {
                    ...response?.data?.user,
                    museum: lastMuseumData?.id,
                    logo_thumbnail: lastMuseumData?.logo_thumbnail,
                    museum_domain: lastMuseumData?.museum_domain_name,
                    museum_name: lastMuseumData?.museum_name,
                    last_used_screen: lastMuseumData?.last_used_screen
                      ? lastMuseumData?.last_used_screen
                      : "",
                  };
                  localStorage.setItem(
                    "user_info",
                    JSON.stringify(newMuseumUserData)
                  );
                }
              }
            }

            if (response?.data?.is_superuser) {
              localStorage.setItem(
                "user_info",
                JSON.stringify(response?.data?.user)
              );
            }

            localStorage.setItem("token", response?.data?.token);
            localStorage.setItem("is_logged", true);

            setTimeout(() => {
              if (response?.data?.user?.is_superuser) {
                navigate(
                  `/${
                    response?.data?.museum_name
                      ? response?.data?.museum_name.split(" ").join("_")
                      : "Nefos"
                  }/${LIST_MUSEUM}`
                );
              } else {
                if (response?.data?.user?.is_admin) {
                  const userData = response?.data?.user?.admin_museums.find(
                    (number) =>
                      number.id === response?.data?.user?.last_login_museum
                  );

                  navigate(
                    `/${userData?.museum_name
                      ?.split(" ")
                      .join("_")}/${HOME_URL}`
                  );
                } else {
                  navigate(
                    `/${response?.data?.user?.museum_name
                      ?.split(" ")
                      .join("_")}/${HOME_URL}`
                  );
                }
              }
            }, 500);
            toast.success("Logged in successfully!");
          } else {
            toast.error(
              response?.message
                ? response?.message
                : "Invalid username or password!"
            );
          }
        });
      } else {
      }
    } catch (error) {
      console.error("Error fetching tokens:", error);
    }
  };
  const loginGoogle = useGoogleLogin({
    flow: "auth-code", // Ensures the Authorization Code flow
    scope: "openid email profile", // Include openid for id_token
    onSuccess: async (codeResponse) => {
      const { code } = codeResponse; // Extract the authorization code
      exchangeCodeForTokens(code); // Call the function to exchange the code
    },
    onError: (error) => console.error("Login Failed:", error),
  });

  useEffect(() => {
    if (user) {
      userLogin();
    }
  }, [user]);

  const unmask = () => {
    setShowPass(!showPass);
  };

  const comingSoonHandler = () => {
    toast.loading("Coming soon");
  };

  return (
    <div className="login-main">
      <div className="login-header">
        <img style={{ width: "100px" }} src={logo} alt="logo" />
        {/* <AiOutlineQuestionCircle
          style={{ fontSize: "20px" }}
          onClick={comingSoonHandler}
        /> */}
      </div>
      <div className="login-container">
        <Container>
          <div className="login-box-container">
            <Row className="login-box-row">
              <div className="login-box">
                <div className="login-title">
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ width: "50px" }} src={logoIcon} alt="logo" />
                  </div>

                  <h3>Welcome back!</h3>
                </div>
                <div className="login-input-box">
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="login-input-field">
                      <CiMail />

                      <Form.Control
                        type="text"
                        placeholder="Email id"
                        name="username"
                        autoComplete="new-username"
                        onChange={formik.handleChange}
                        value={formik.values.username}
                        disabled={false} // Explicitly ensure it is enabled
                        readOnly={false} // En
                      />
                      {formik.touched?.username &&
                        !!formik?.errors?.username && (
                          <div className="show-valid">
                            <RiErrorWarningLine
                              style={{
                                color: "#dc3545",
                                fontSize: "21px",
                                cursor: "pointer",
                              }}
                            />

                            <p>{formik?.errors?.username}</p>
                          </div>
                        )}
                    </div>
                    <div className="login-input-field">
                      <CiLock />
                      <Form.Control
                        type={showPass ? "text" : "password"}
                        placeholder="Password"
                        name="password"
                        autoComplete="new-password"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      {formik.values.password ? (
                        <button
                          className="password-button_icon"
                          type="button"
                          onClick={unmask}
                        >
                          {showPass ? <MdVisibility /> : <RxEyeClosed />}
                        </button>
                      ) : (
                        ""
                      )}
                      {formik.touched?.password &&
                        !!formik?.errors?.password && (
                          <div className="show-valid">
                            <RiErrorWarningLine
                              style={{
                                color: "#dc3545",
                                fontSize: "21px",
                                cursor: "pointer",
                              }}
                            />

                            <p>{formik?.errors?.password}</p>
                          </div>
                        )}
                    </div>
                    <div className="login-submit-btn">
                      <button type={buttonloader ? "button" : "submit"}>
                        {buttonloader ? <SimpleBackdrop /> : "Sign in"}
                      </button>
                    </div>
                  </Form>
                </div>
                <div className="forgot-password-box">
                  <Link to={FORGOT_PASSWORD}>
                    <p>Forgot password?</p>
                  </Link>
                </div>
                <div className="or-box">
                  <p>OR</p>
                </div>
                <div o className="google-box" onClick={() => loginGoogle()}>
                  <Box
                    sx={{
                      padding: "10px",
                      backgroundColor: "#C9C3BE",

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "5px",
                      borderRadius: "20px",
                    }}
                  >
                    Sign in with Google
                    <FcGoogle />
                  </Box>
                </div>
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Login;
